module.exports = window["toastr"];